import React, { useState, useEffect } from 'react';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';
import Loader from '../../UI/Icons/Loader/Loader';
import { BREAKPOINTS } from '../../../constants/breakpoints';

const DESKTOP_WIDTH = BREAKPOINTS.large;

const AccessoriesSlide = ({ product, addToCart }) => {
  const [fetching, setFetching] = useState(false);

  const properties = {
    quantity: 1,
    id: product?.variants[0]?.id,
  };

  const [isDesktop, setIsDesktop] = useState(null);

  useEffect(() => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
  };

  const addAction = async () => {
    setFetching(true);
    await addToCart(properties, product?.title)
      .then(() => setFetching(false))
      .catch(() => {
        setFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  return (
    <div className="c-accessories__slide">
      <div className="c-accessories__slide-image">
        <img src={product?.image?.url} alt={product?.image?.alt} />
      </div>
      <div className="c-accessories__slide-text">
        <div className="c-accessories__slide-title-container">
          <div className="c-accessories__slide-title h4-roobert color-black">
            <h4>
              <a className="color-black" href={product?.url}>
                {product?.title}
              </a>
            </h4>
          </div>
          {!isDesktop && (
            <div className="c-accessories__slide-details">
              <div className="c-accessories__slide-details-container color-black text-cta cta">
                <a className="color-black" href={product?.url}>
                  See details
                </a>
              </div>
            </div>
          )}
        </div>
        {product?.description && (
          <div className="c-accessories__slide-description body-1 color-black">
            <p>{product?.description}</p>
          </div>
        )}
        {isDesktop && (
          <div className="c-accessories__slide-details color-black text-cta cta">
            <a className="color-black" href={product?.url}>
              See details
            </a>
          </div>
        )}
        <div className="c-accessories__slide-add-to-cart">
          <CTAButton
            isButton={true}
            onClick={product?.variants[0]?.available ? addAction : null}
            ariaLabel={
              product?.variants[0]?.available ? `Add To Cart–${product?.price}` : 'Sold Out'
            }
            type={product?.variants[0]?.available ? 'secondary' : 'primary'}
            text={
              product?.variants[0]?.available ? (
                fetching ? (
                  <Loader lightMode={true} />
                ) : (
                  `Add to Cart–${product?.price}`
                )
              ) : (
                'Sold Out'
              )
            }
            additionalClasses={`cta ${product?.variants[0]?.available ? 'color-black' : ''}`}
            disabled={!product?.variants[0]?.available}
          />
        </div>
      </div>
    </div>
  );
};

export default AccessoriesSlide;
